import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Tab } from '../../components/detail/details/detail-tabbar/detail-tabbar.component';

@Injectable()
export class DetailPageService {
  private readonly _currentTab$ = new BehaviorSubject<Tab>('Informationen');
  public currentTab$ = this._currentTab$.asObservable();

  setCurrentTab(tab: Tab): void {
    this._currentTab$.next(tab);
  }
}
